// extracted by mini-css-extract-plugin
export default {"project_paginate_number":"styles_project_paginate_number__sGGX9","active":"styles_active__lj0-U","prev":"styles_prev__1VRMF","next":"styles_next__c4mk2"};